import { assert, IGNORED, Test } from "oc-e2e-testrunner";
import { resetArrangement } from "./utils";
import {
  applyProfileChangeToElements,
  filterByUniqueProfiles,
} from "../arrangement/elementFunctions";
import { findPathIntersectionCached } from "oc-app/metadata/GraphMetadata";
import { MObjekt, MProfilkategorie } from "../../metamodell";
import { PAuswahlwert } from "../../metamodell_paths";

export default {
  name: "TestDekorprofilePosition",
};

export const testEinzeltorMitDekorprofilIstSondertor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.massAuswahlwert = massAuswahlwert;
  element.rahmenAuswahlwert = APP.richMetadata.findAuswahlwert("Tor_Rahmen_Anthrazit");
  element.form = findPathIntersectionCached("TestDekorprofilePosition.ts:21")(
    massAuswahlwert,
    (p: PAuswahlwert) => p.Mass.Form
  ) as MObjekt;
  element.setBreite(0.98);
  element.höhe = 1.8;
  agt.update3d();
  assert.deepEquals(
    {
      breite: 0.98,
      höhe: 1.8,
      key: "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links",
    },
    { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
    "Massauswahlwert auf Standardtor gesetzt"
  );
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach"),
      key: "3761 SYSTEM WPC Classic Sondertor mit Dekorprofil zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert,
      key: element.meta.Key,
    },
    "Dekorprofil eingefügt"
  );
};

export const testEinzeltorMitDekorprofilUnd120BreiteIstMasstor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  element.massAuswahlwert = massAuswahlwert;
  element.rahmenAuswahlwert = APP.richMetadata.findAuswahlwert("Tor_Rahmen_Anthrazit");
  element.form = findPathIntersectionCached("TestDekorprofilePosition.ts:21")(
    massAuswahlwert,
    (p: PAuswahlwert) => p.Mass.Form
  ) as MObjekt;
  element.setBreite(0.98);
  element.höhe = 1.8;
  agt.update3d();
  assert.deepEquals(
    {
      breite: 0.98,
      höhe: 1.8,
      key: "2570 SYSTEM WPC Standard Einzeltor Classic Anth/Anth DIN Links",
    },
    { breite: element.breite, höhe: element.höhe, key: element.meta.Key },
    "Massauswahlwert auf Standardtor gesetzt"
  );
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  element.setBreite(1.2);
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach"),
      key: "2499 SYSTEM WPC Classic Mass Einzeltor zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert,
      key: element.meta.Key,
    },
    "Dekorprofil eingefügt"
  );
};

// Zaunfelder mit Dekorprofilen

export const testDekorprofilPosition15cmProfil15cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile15cm_ZaunSets"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/flach",
      profilPosition: 11,
      key: "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Dekorprofil in 15cm Zaunfeld WPC Classic ist 11"
  );
};

export const testDekorprofilPosition30cmProfil15cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile30cm_ZaunSets"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 10,
      key: "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 15cm Zaunfeld WPC Classic ist 10"
  );
};

export const testDekorprofilPositionDesignprofil15cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Designprofile_Steckzaun_Zaunfeld"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM_Designprofil_silber");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM_Designprofil_silber",
      profilPosition: 12,
      key: "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Designprofil in 15cm Zaunfeld WPC Classic ist 12"
  );
};

export const testDekorprofilPosition15cmAkzentfarbe15cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Zaunfeld_WPC_15cm"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Sand");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM WPC CLASSIC Sand",
      profilPosition: 12,
      key: "2143 SYSTEM WPC CLASSIC  Anthrazit/Anthrazit Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Akzentfarbe in 15cm Zaunfeld WPC Classic ist 12"
  );
};

export const testDekorprofilPosition15cmAkzentfarbe30cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Zaunfeld_WPC_15cm"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Sand");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM WPC XL Sand",
      profilPosition: 6,
      key: "2594 SYSTEM WPC XL Anthrazit/Anthrazit  Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Akzentfarbe in 30cm Zaunfeld WPC XL ist 6"
  );
};

export const testDekorprofilPositionDesignprofil30cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Designprofile_Steckzaun_Zaunfeld"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM_Designprofil_silber");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM_Designprofil_silber",
      profilPosition: 6,
      key: "2594 SYSTEM WPC XL Anthrazit/Anthrazit  Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Designprofil in 30cm Zaunfeld WPC XL ist 6"
  );
};

export const testDekorprofilPosition15cmProfil30cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile30cm_ZaunSets"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 5,
      key: "2594 SYSTEM WPC XL Anthrazit/Anthrazit  Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 30cm Zaunfeld WPC XL ist 5"
  );
};

export const testDekorprofilPosition30cmProfil30cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile30cm_ZaunSets"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 5,
      key: "2594 SYSTEM WPC XL Anthrazit/Anthrazit  Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 30cm Zaunfeld WPC XL ist 5"
  );
};

export const testDekorprofilPosition30cmAkzentfarbe30cmZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Zaunfeld_WPC_30cm"
  );
  const profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Grau");
  element.profilAuswahlwert = profilAuswahlwert;
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM WPC XL Grau",
      profilPosition: 6,
      key: "2594 SYSTEM WPC XL Anthrazit/Anthrazit  Zaunfeld-Set 178 x 183 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Akzentfarbe in 30cm Zaunfeld WPC XL ist 6"
  );
};

export const testDekorprofilPosition15cmProfilRhombusZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Vintage Oak");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile_15cm_Zaunfeld_Rhombus"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/flach",
      profilPosition: 26,
      key: "2955 SYSTEM RHOMBUS Vintage Oak 180 x 180  cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Dekorprofil in Rhombus Zaunfeld ist 26"
  );
};

export const testDekorprofilPosition30cmProfilRhombusZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Vintage Oak");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Dekorprofile_30cm_Zaunfeld_Rhombus"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 24,
      key: "2955 SYSTEM RHOMBUS Vintage Oak 180 x 180  cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in Rhombus Zaunfeld ist 26"
  );
};

export const testDekorprofilPositionAkzentfarbeRhombusZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Vintage Oak");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Rhombus_5_Zaunfeld"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM Rhombus Lärche Akzentfarbe");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM Rhombus Lärche Akzentfarbe",
      profilPosition: 26,
      key: "2955 SYSTEM RHOMBUS Vintage Oak 180 x 180  cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Akzentfarbe in Rhombus Zaunfeld ist 26"
  );
};

export const testDekorprofilPositionKeramikXLZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik XL Eiche");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Keramik XL Zement");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Keramik XL Zement",
      profilPosition: 3,
      key: "2931 SYSTEM KERAMIK XL Eiche 180 x 180 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Keramik XL Zaunfeld ist 3"
  );
};

export const testDekorprofilPositionBoardXLZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Schiefer");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM BOARD XL Marmor");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM BOARD XL Marmor",
      profilPosition: 4,
      key: "2800 SYSTEM BOARD XL Schiefer  Zaunfeld-Set 179 x 180 cm",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Board XL Zaunfeld ist 4"
  );
};

// Tore mit Dekorprofilen

export const testDekorprofilPosition15cmProfil15cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/flach",
      profilPosition: 11,
      key: "3761 SYSTEM WPC Classic Sondertor mit Dekorprofil zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Dekorprofil in 15cm Einzeltor WPC Classic ist 11"
  );
};

export const testDekorprofilPositionDesignprofil15cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Designprofile_Steckzaun_Tore"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM_Designprofil_silber");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM_Designprofil_silber",
      profilPosition: 12,
      key: "3761 SYSTEM WPC Classic Sondertor mit Dekorprofil zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für Designprofil in 15cm Einzeltor WPC Classic ist 12"
  );
};

export const testDekorprofilPosition15cmAkzentfarbe15cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Tore_WPC_15cm"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Sand");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "SYSTEM WPC CLASSIC Sand",
      profilPosition: 12,
      key: "2966 SYSTEM WPC Classic Sondertor zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 15cm Akzentfarbe in 15cm Einzeltor WPC Classic ist 12"
  );
};

export const testDekorprofilPosition30cmAkzentfarbe15cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert(
    "Basisprofile_Sondertore_WPC_XL_30cm"
  );
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Omega Anthrazit/flach");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Omega Anthrazit/flach",
      profilPosition: 11,
      key: "3761 SYSTEM WPC Classic Sondertor mit Dekorprofil zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Akzentfarbe in 15cm Einzeltor WPC Classic ist 11"
  );
};

export const testDekorprofilPosition30cmProfil15cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile30cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 10,
      key: "3761 SYSTEM WPC Classic Sondertor mit Dekorprofil zweiseitig_15",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 15cm Einzeltor WPC Classic ist 10"
  );
};

export const testDekorprofilPosition15cmProfil30cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile30cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 5,
      key: "3761 SYSTEM WPC XL Sondertor mit Dekorprofil einseitig_30",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 30cm Einzeltor WPC XL ist 5"
  );
};

export const testDekorprofilPosition30cmProfil30cmEinzeltor: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC XL Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({
    füllungAuswahlwert,
    massAuswahlwert,
  });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile30cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");
  agt.update3d();
  element.profilPosition = element.sonderprofilMinMax.maxPosition;
  agt.update3d();
  assert.deepEquals(
    {
      showProfil: true,
      profilAuswahlwert: "Dekor Bubble Edelstahl/hoch",
      profilPosition: 5,
      key: "3761 SYSTEM WPC XL Sondertor mit Dekorprofil einseitig_30",
    },
    {
      showProfil: element.showProfil,
      profilAuswahlwert: element.profilAuswahlwert.Key,
      profilPosition: element.profilPosition,
      key: element.meta.Key,
    },
    "Standard-Profilposition für 30cm Dekorprofil in 30cm Einzeltor WPC XL ist 5"
  );
};

/**
 * Test: Globale Profilposition wird an neue Dekorprofile weitergegeben.
 * Szenario: Element A bekommt ein Dekorprofil, Position wird auf 3 gesetzt.
 * Element B bekommt danach ein Dekorprofil → soll Position 3 erhalten.
 */
export const testGlobaleProfilPositionWirdPropagiert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4.0]);
  agt.fillIndividuellSegmentsWithElements();

  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  agt.update3d();

  const element1 = agt.segmente[0].getElemente()[0];
  const element2 = agt.segmente[0].getElemente()[1];

  // Element 1 bekommt Dekorprofil (Zaunfeld-Kategorie!)
  const kategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_ZaunSets");
  const profil = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  applyProfileChangeToElements([element1], kategorieAuswahlwert, { profil });
  agt.update3d();

  // Position explizit auf 3 setzen und als globale Position tracken
  element1.profilPosition = 3;
  agt.profilPosition_ = 3;
  agt.update3d();

  assert.equals(3, element1.profilPosition, "Element 1 hat Profilposition 3");
  assert.equals(3, agt.profilPosition_, "Globale Profilposition ist 3");

  // Element 2 bekommt jetzt Dekorprofil → soll Position 3 übernehmen
  applyProfileChangeToElements([element2], kategorieAuswahlwert, { profil });
  agt.update3d();

  assert.deepEquals(
    {
      position1: 3,
      position2: 3,
      showProfil2: true,
    },
    {
      position1: element1.profilPosition,
      position2: element2.profilPosition,
      showProfil2: !!element2.showProfil,
    },
    "Element 2 übernimmt die globale Profilposition 3 von Element 1"
  );
};

/**
 * Test: Zuletzt gesetzte Profilposition wird an weitere Elemente propagiert.
 * Szenario: Element A hat Position 3, Element B bekommt Position 2.
 * Element C soll dann Position 2 bekommen (die zuletzt gesetzte).
 */
export const testLetzteProfilPositionWirdPropagiert: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [6.0]);
  agt.fillIndividuellSegmentsWithElements();

  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  agt.update3d();

  const elemente = agt.segmente[0].getElemente();
  if (elemente.length < 3) {
    assert.equals(true, false, "Nicht genug Elemente für den Test (benötigt mind. 3)");
    return;
  }

  const kategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_ZaunSets");
  const profil = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");

  // Element 1: Dekorprofil mit Position 3
  applyProfileChangeToElements([elemente[0]], kategorieAuswahlwert, { profil });
  elemente[0].profilPosition = 3;
  agt.profilPosition_ = 3;
  agt.update3d();

  // Element 2: Dekorprofil, ändere Position auf 2
  applyProfileChangeToElements([elemente[1]], kategorieAuswahlwert, { profil });
  agt.update3d();
  elemente[1].profilPosition = 2;
  agt.profilPosition_ = 2;
  agt.update3d();

  // Element 3: Dekorprofil hinzufügen → soll Position 2 bekommen (zuletzt gesetzt)
  applyProfileChangeToElements([elemente[2]], kategorieAuswahlwert, { profil });
  agt.update3d();

  assert.deepEquals(
    {
      position1: 3,
      position2: 2,
      position3: 2,
      globalePosition: 2,
    },
    {
      position1: elemente[0].profilPosition,
      position2: elemente[1].profilPosition,
      position3: elemente[2].profilPosition,
      globalePosition: agt.profilPosition_,
    },
    "Element 3 bekommt die zuletzt gesetzte Position 2"
  );
};

/**
 * Test: Dekorprofil-Individualisierung: Wenn Elemente selektiert sind,
 * wird profilAuswahlwertIndividualisiert gesetzt. Beim globalen Setzen
 * werden individualisierte Elemente übersprungen.
 */
export const testDekorprofilIndividualisierungBeimGlobalenSetzen: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4.0]);
  agt.fillIndividuellSegmentsWithElements();

  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  agt.update3d();

  const element1 = agt.segmente[0].getElemente()[0];
  const element2 = agt.segmente[0].getElemente()[1];

  const kategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_ZaunSets");
  const profil1 = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  const profil2 = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/hoch");

  // Beide Elemente bekommen Profil1
  applyProfileChangeToElements([element1, element2], kategorieAuswahlwert, { profil: profil1 });
  agt.update3d();

  // Element 1 wird individualisiert mit Profil2
  applyProfileChangeToElements([element1], kategorieAuswahlwert, { profil: profil2 }, true);
  agt.update3d();

  assert.equals(true, element1.profilAuswahlwertIndividualisiert,
    "Element 1 ist als individualisiert markiert");
  assert.equals(profil2.Key, element1.profilAuswahlwert?.Key,
    "Element 1 hat individualisiertes Profil2");

  // Globales Setzen auf profil1 soll Element 1 überspringen
  applyProfileChangeToElements([element1, element2], kategorieAuswahlwert, { profil: profil1 });
  agt.update3d();

  assert.equals(profil2.Key, element1.profilAuswahlwert?.Key,
    "Element 1 behält individualisiertes Profil2 nach globalem Setzen");
  assert.equals(profil1.Key, element2.profilAuswahlwert?.Key,
    "Element 2 hat das global gesetzte Profil1");
};

/**
 * Test: Wenn Profil-Elemente unterschiedliche Positionen haben (gemischt),
 * wird kein Wert angezeigt. Beim erneuten Auswählen einer Position werden
 * alle Elemente überschrieben und die Individualisierung aufgehoben.
 */
export const testGlobalePositionÜberschreibtAlleIndividualisiertenPositionen: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [4.0]);
  agt.fillIndividuellSegmentsWithElements();

  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  agt.update3d();

  const element1 = agt.segmente[0].getElemente()[0];
  const element2 = agt.segmente[0].getElemente()[1];

  const kategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_ZaunSets");
  const profil = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");

  // Beide Elemente bekommen Dekorprofil
  applyProfileChangeToElements([element1, element2], kategorieAuswahlwert, { profil });
  agt.update3d();

  // Individuell unterschiedliche Positionen setzen
  element1.profilPosition = 3;
  element1.profilPositionIndividualisiert = true;
  element2.profilPosition = 5;
  element2.profilPositionIndividualisiert = true;
  agt.update3d();

  // Prüfen: Positionen sind gemischt
  const hatGemischtePositionen = element1.profilPosition !== element2.profilPosition;
  assert.equals(true, hatGemischtePositionen, "Positionen sind gemischt");

  // Simuliere: User setzt global Position 7 (= Setter in DekorOptionen bei gemischten Positionen)
  const elementeMitProfil = [element1, element2];
  elementeMitProfil.forEach((e) => {
    e.profilPosition = 7;
    e.profilPositionIndividualisiert = false;
  });
  agt.profilPosition_ = 7;
  agt.update3d();

  assert.deepEquals(
    { pos1: 7, pos2: 7, ind1: false, ind2: false, globalPos: 7 },
    {
      pos1: element1.profilPosition,
      pos2: element2.profilPosition,
      ind1: element1.profilPositionIndividualisiert,
      ind2: element2.profilPositionIndividualisiert,
      globalPos: agt.profilPosition_,
    },
    "Globale Position 7 überschreibt alle individualisierten Positionen und setzt Flags zurück"
  );
};

/**
 * Test: ProfilPosition bleibt nach APP.dirty() / update3d() erhalten
 * und wird nicht durch updateMetas überschrieben.
 */
export const testProfilPositionBleibtNachUpdateErhalten: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [3.0]);
  agt.fillIndividuellSegmentsWithElements();

  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("180x180_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  agt.update3d();

  const element = agt.segmente[0].getElemente()[0];
  const kategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_ZaunSets");
  const profil = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");

  applyProfileChangeToElements([element], kategorieAuswahlwert, { profil });
  agt.update3d();

  const defaultPosition = element.profilPosition;

  // Position explizit ändern
  element.profilPosition = 2;
  agt.update3d();

  assert.equals(2, element.profilPosition,
    "Profilposition 2 bleibt nach update3d erhalten");

  // Nochmal update3d — Position darf nicht zurückspringen
  agt.update3d();
  assert.equals(2, element.profilPosition,
    "Profilposition 2 bleibt auch nach zweitem update3d erhalten");
};

/**
 * Test: ProfilPosition bei Toren bleibt nach toJSON/fromJSON (Speichern/Laden) erhalten.
 */
export const testProfilPositionTorBleibtNachSpeichernLadenErhalten: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_Tore");
  element.profilAuswahlwert = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  agt.update3d();

  // Position explizit setzen
  element.profilPosition = 7;
  agt.update3d();
  assert.equals(7, element.profilPosition, "Profilposition ist 7 vor dem Speichern");

  // Roundtrip: Speichern und Laden
  const json = agt.toJSON();
  agt.fromJSON(json);
  agt.update3d();

  const elementNachLaden = agt.segmente[0].getElemente()[0];
  assert.equals(7, elementNachLaden.profilPosition,
    "Profilposition muss nach Speichern/Laden gleich bleiben (7)");
  assert.equals(true, elementNachLaden.showProfil,
    "showProfil muss nach Speichern/Laden erhalten bleiben");
  assert.equals("Dekor Bubble Edelstahl/flach", elementNachLaden.profilAuswahlwert?.Key,
    "profilAuswahlwert muss nach Speichern/Laden erhalten bleiben");
};

/**
 * Test: Nach Entfernen der Dekorprofile wird der globale profilAuswahlwert zurückgesetzt,
 * sodass im Menü kein nicht-existentes Dekor mehr ausgewählt angezeigt wird.
 */
export const testEntfernenDekorprofilResettetGlobalenAuswahlwert: Test = async () => {
  resetArrangement(true);
  const agt = APP.arrangement;
  const breite = 2.3;
  agt.grundriss.setStandardForm("Strecke", [breite]);
  agt.fillIndividuellSegmentsWithElements();
  const s = agt.segmente[0];
  s.getElemente()[0].uiRemove();
  agt.update3d();
  const element = s.getElemente()[0];
  const füllungAuswahlwert = APP.richMetadata.findAuswahlwert("SYSTEM WPC CLASSIC Anthrazit");
  const massAuswahlwert = APP.richMetadata.findAuswahlwert("Einzeltor_Easy");
  agt.changeSelectedZaunElemente({ füllungAuswahlwert, massAuswahlwert });
  element.showProfil = true;
  element.profilKategorieAuswahlwert = APP.richMetadata.findAuswahlwert("Dekorprofile15cm_Tore");
  const profil = APP.richMetadata.findAuswahlwert("Dekor Bubble Edelstahl/flach");
  element.profilAuswahlwert = profil;
  agt.update3d();

  // Prüfen, dass Profil gesetzt ist
  assert.equals(profil.Key, element.profilAuswahlwert?.Key,
    "Dekorprofil ist gesetzt vor dem Entfernen");
  assert.equals(true, element.showProfil,
    "showProfil ist true vor dem Entfernen");

  // Profil entfernen (wie in DekorOptionen.removeProfile)
  const elemente = agt.getSelectedOrAllElemente();
  elemente.forEach((e) => {
    e.showProfil = null;
    e.profilKategorieAuswahlwert = null;
    e.profilAuswahlwert = null;
    e.profilPosition = null;
  });
  agt.update3d();

  // showProfil muss null/false sein nach dem Entfernen
  assert.isTrue(!element.showProfil,
    "showProfil ist falsy nach dem Entfernen");

  // Der globale profilAuswahlwert auf dem Arrangement darf nicht mehr
  // auf das entfernte Dekorprofil zeigen (das war der eigentliche Bug:
  // im Menü wurde das entfernte Profil weiterhin als ausgewählt angezeigt)
  const globalerWert = agt.profilAuswahlwert;
  assert.isTrue(
    globalerWert == null || globalerWert.Key !== profil.Key,
    "Globaler profilAuswahlwert darf nach Entfernen nicht mehr auf das entfernte Dekorprofil zeigen"
  );
};

/**
 * Test: "Dekorprofile 30cm" darf in der Dekore-Leiste nicht doppelt erscheinen,
 * wenn ein Zaunfeld und ein Schiebetor derselben Serie kombiniert werden.
 *
 * Hintergrund (Bug): Zaunfeld, Mass-Tor und Schiebetor besitzen drei verschiedene
 * Profilkategorien mit identischem Anzeigenamen "Dekorprofile 30cm". Die Profile
 * der beiden Mass-Varianten (Mass-Tor / Schiebetor) sind eine Teilmenge der
 * Zaunfeld-Profile, weshalb filterByUniqueProfiles sie zu genau EINEM Eintrag
 * zusammenfassen muss (die Nicht-Mass-Zaunfeld-Kategorie wird bevorzugt).
 *
 * Der Fehler trat reihenfolgenabhängig auf: Traf die Schiebetor-Kategorie zuerst
 * auf die gleich große Mass-Tor-Kategorie, wurde nur diese ausgeschieden und
 * danach abgebrochen – die Schiebetor-Kategorie überlebte dann neben der
 * Zaunfeld-Kategorie. Deshalb wird hier bewusst die auslösende Reihenfolge
 * [Zaunfeld, Mass-Tor, Schiebetor] geprüft.
 */
export const testDekorprofile30cmNichtDoppeltBeiSchiebetorUndZaunfeld: Test = async () => {
  resetArrangement();
  const agt = APP.arrangement;
  agt.grundriss.setStandardForm("Strecke", [8]);
  agt.update3d();
  agt.fillIndividuellSegmentsWithElements();
  agt.update3d();

  const segment = agt.segmente[0];
  // Alle Elemente auf NEO Holz Zaunfeld setzen
  agt.setSelectedObjects(segment.getElemente());
  await agt.changeSelectedZaunElemente({
    füllungAuswahlwert: APP.richMetadata.findAuswahlwert("SYSTEM NEO HOLZ Thermoholz"),
    massAuswahlwert: APP.richMetadata.findAuswahlwert("180x180_Easy"),
  });
  agt.update3d();

  // Erstes Element zu einem Schiebetor umwandeln
  agt.setSelectedObjects([segment.getElemente()[0]]);
  await agt.changeSelectedZaunElemente({
    massAuswahlwert: APP.richMetadata.findAuswahlwert("Schiebetor_Easy"),
  });
  agt.update3d();
  agt.setSelectedObjects([]);
  agt.update3d();

  // Die drei "rich" Profilkategorien einsammeln, wie es getRichProfilkategorien tut
  // (aus den Element-Backrefs und den möglichen Auswahlwerten der Profilkategorie-Auswahl).
  const Profilkategorie = agt.auswahlAccessoren.Profilkategorie;
  const alle: MProfilkategorie[] = [
    ...agt.getElemente().flatMap((e) => e.meta?.Profilkategorie ?? []),
    ...(Profilkategorie?.möglicheAuswahlwerte ?? [])
      .map((p) => (p.Profilkategorie ?? [])[0])
      .filter(Boolean),
  ];
  const byKey = (k: string) => alle.find((pk) => pk.Key === k);
  const zaunfeld = byKey("Dekorprofile_30cm_Zaunfeld_NEO_Holz_10");
  const massTor = byKey("Dekorprofile_Mass_Tor_30cm_NEO_Holz_10");
  const schiebetor = byKey("Dekorprofile_Schiebetor_Mass_Tor_30cm_NEO_Holz_10");

  // Vorbedingung: Alle drei Kategorien müssen existieren und denselben Namen tragen.
  assert.deepEquals(
    {
      zaunfeld: "Dekorprofile 30cm",
      massTor: "Dekorprofile 30cm",
      schiebetor: "Dekorprofile 30cm",
    },
    {
      zaunfeld: zaunfeld?.Auswahlwert?.Name,
      massTor: massTor?.Auswahlwert?.Name,
      schiebetor: schiebetor?.Auswahlwert?.Name,
    },
    "Zaunfeld-, Mass-Tor- und Schiebetor-Profilkategorie existieren und heißen alle 'Dekorprofile 30cm'"
  );

  // In der auslösenden Reihenfolge dedupliziert filterByUniqueProfiles auf genau
  // eine Kategorie – und zwar die Nicht-Mass-Zaunfeld-Kategorie.
  const survivors = filterByUniqueProfiles([zaunfeld, massTor, schiebetor]);
  const dekor30Survivors = survivors.filter(
    (pk) => pk.Auswahlwert?.Name === "Dekorprofile 30cm"
  );

  assert.deepEquals(
    {
      anzahlDekorprofile30cm: 1,
      überlebendeKategorie: "Dekorprofile_30cm_Zaunfeld_NEO_Holz_10",
    },
    {
      anzahlDekorprofile30cm: dekor30Survivors.length,
      überlebendeKategorie: dekor30Survivors[0]?.Key,
    },
    "'Dekorprofile 30cm' erscheint nach Dedup nur einmal (Zaunfeld-Kategorie bleibt)"
  );
};

